module.exports = __webpack_public_path__ + "img/menuimg3.2a720141.png";